import React, { useState } from 'react';
import PipelineStepper from '../ui/PipelineStepper.jsx';

const CancelConfirmModal = ({ onConfirm, onCancel, t }) => (
  <div
    onClick={onCancel}
    role="dialog"
    aria-modal="true"
    style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.55)', backdropFilter: 'blur(4px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '24px',
    }}
  >
    <div
      onClick={e => e.stopPropagation()}
      style={{
        background: t.inputBg || '#1a1a2e', borderRadius: '16px',
        border: '1.5px solid rgba(239,68,68,0.4)',
        padding: '28px 28px 24px',
        maxWidth: '420px', width: '100%',
        boxShadow: '0 24px 60px rgba(0,0,0,0.5)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px' }}>
        <span style={{ fontSize: '20px' }}>⚠️</span>
        <span style={{ fontSize: '15px', fontWeight: 700, color: '#EF4444' }}>Annullare la generazione?</span>
      </div>
      <p style={{ margin: 0, fontSize: '14px', lineHeight: 1.6, color: t.text }}>
        La run pipeline verrà interrotta e il contenuto in corso andrà perso. Vuoi davvero procedere?
      </p>
      <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
        <button
          onClick={onCancel}
          style={{
            flex: 1, padding: '10px', borderRadius: '10px',
            border: `1px solid ${t.border || 'rgba(255,255,255,0.1)'}`,
            background: 'transparent', color: t.text,
            fontSize: '13px', fontWeight: 600, cursor: 'pointer',
          }}
        >
          Continua generazione
        </button>
        <button
          onClick={onConfirm}
          style={{
            flex: 1, padding: '10px', borderRadius: '10px',
            border: '1px solid rgba(239,68,68,0.4)',
            background: 'rgba(239,68,68,0.12)', color: '#EF4444',
            fontSize: '13px', fontWeight: 600, cursor: 'pointer',
          }}
        >
          Annulla generazione
        </button>
      </div>
    </div>
  </div>
);

const Step2Generate = ({ progress, color, w, t, onCancel }) => {
  const [confirmOpen, setConfirmOpen] = useState(false);

  if (!progress) return null;

  const showCancel =
    typeof onCancel === 'function' &&
    !progress.isComplete && !progress.isError && !progress.isCancelled;

  const pending = progress.cancelStatus === 'pending';
  const tooLate = progress.nonCancellable || progress.cancelStatus === 'too-late';
  const disabled = pending || tooLate;

  const label = tooLate
    ? 'Non più annullabile (fase finale)'
    : pending
    ? 'Annullamento…'
    : 'Annulla generazione';

  const handleClick = () => {
    if (disabled) return;
    setConfirmOpen(true);
  };

  const handleConfirm = () => {
    setConfirmOpen(false);
    onCancel();
  };

  return (
    <div style={{
      padding: '20px',
      background: t.surface,
      borderRadius: '14px',
      border: `1px solid ${t.border}`,
    }}>
      <PipelineStepper
        slots={progress.slots}
        activePhase={progress.activePhase}
        isComplete={progress.isComplete}
        isError={progress.isError}
        isCancelled={progress.isCancelled}
        errorMessage={progress.errorMessage}
        warningsCount={progress.warningsCount}
        slotTimings={progress.slotTimings}
        color={color}
        theme={t}
        w={w}
      />
      {showCancel && (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '8px' }}>
          <button
            onClick={handleClick}
            disabled={disabled}
            style={{
              padding: '10px 18px', borderRadius: '10px',
              border: `1px solid ${t.border}`,
              background: t.surface,
              color: disabled ? (t.textDim || '#7a7a8e') : t.textMuted,
              fontSize: '13px', fontWeight: 600,
              cursor: disabled ? 'not-allowed' : 'pointer',
              opacity: disabled ? 0.6 : 1,
              transition: 'all 0.2s',
            }}
          >
            {label}
          </button>
        </div>
      )}
      {confirmOpen && (
        <CancelConfirmModal
          onConfirm={handleConfirm}
          onCancel={() => setConfirmOpen(false)}
          t={t}
        />
      )}
    </div>
  );
};

export default Step2Generate;
